const translationContext = "admin.brokers.enums";
export default [
  { value: "FIXED", key: `${translationContext}.fixed` },
  { value: "PERCENTAGE", key: `${translationContext}.percentage` },
];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/enums/calculationTypeOptions.js